import { datadogRum } from '@datadog/browser-rum';

const { VITE_STAGE } = import.meta.env;

export type DefaultErrorParams = {
  name?: string;
  message?: string;
  title?: string;
  error?: Error;
};

export class DefaultError extends Error {
  title: string;
  keyword: string;
  response:
    | {
        status: string;
        statusText: string;
        data: string;
        config: { url: string };
      }
    | unknown;
  cause?: Error;

  constructor({ error, name, message, title }: DefaultErrorParams) {
    super(error?.message);

    /* istanbul ignore next -- @preserve */
    if (Error.captureStackTrace) {
      Error.captureStackTrace(this, this.constructor);
    }

    this.name = name ?? DefaultError.name;
    this.title = title ?? 'Error';
    this.message = message ?? error?.message ?? 'Unexpected error';
    this.keyword = '';
    this.response = {
      status: '',
      statusText: '',
      data: '',
      config: { url: '' }
    };
    this.cause = error as Error;

    this.#logError();
  }

  static get name() {
    return 'DefaultError';
  }

  #logError() {
    console.error(
      `${this.stack} \n\n:: caused by :: \n\n ${this.cause?.stack}`
    );
    /* istanbul ignore next -- @preserve */
    if (VITE_STAGE !== 'test') {
      datadogRum.addError(this, {
        stack: this.stack
      });
    }
  }

  toJson() {
    return JSON.parse(JSON.stringify(this, Object.getOwnPropertyNames(this)));
  }
}
